export * from './ScrollLock';
//# sourceMappingURL=index.js.map